export const CONFIG = {
  CP_API_URL: '__CP_API_URL__',
  CONTROL_PLANE_ENV: '__CONTROL_PLANE_ENV__',
  GOOGLE_CLIENT_ID: '__GOOGLE_CLIENT_ID__',
  GITHUB_CLIENT_ID: '__GITHUB_CLIENT_ID__',
  STRIPE_PUBLIC_KEY: '__STRIPE_PUBLIC_KEY__',
  STRIPE_PAYMENT_METHOD_CONFIG: '__STRIPE_PAYMENT_METHOD_CONFIG__',
  YEAR: '__YEAR__'
}